module.exports = __webpack_public_path__ + "static/media/icon-character__nicolae-ceausescu-hover.f970366a.svg";